import type { EventLogState } from "@/lib/sse/useSSE";

/**
 * Returns the scenario id of the most recently fired ui.ScreenChanged
 * event. Used to branch component behaviour on the active scenario
 * (T1 vs T2 vs T3 etc) without threading the id through props.
 *
 * Returns "" if no ScreenChanged event has fired yet (idle session).
 */
export function inferActiveScenario(ev: EventLogState): string {
  for (let i = ev.events.length - 1; i >= 0; i--) {
    const e = ev.events[i];
    if (e.eventType === "ui.ScreenChanged") return e.correlationId ?? "";
  }
  return "";
}
